$( document ).ready(function() {
  //////////////////////////////////////////////////////////// Home Page ////////////////////////////////////////////////////////
  if ( $("body").hasClass("index") ){
    /*** Course Type Click Event ***/
    $(document).on("click", ".home-upcoming-courses .courses-types .course-type", function(e){
      $(".home-upcoming-courses .courses-types .course-type").removeClass("course-type--active");
      $(this).addClass("course-type--active");

      // Update Course item lists
      let courseName = $(this).data('course-name');
      $(".home-upcoming-courses .course-lists .course-list").removeClass("course-list--active");
      $(`.home-upcoming-courses .course-lists .course-list[data-course-name="${courseName}"]`).addClass("course-list--active");

      // Update Course item image
      let blockID = $(`.home-upcoming-courses .course-lists .course-list[data-course-name="${courseName}"] .course-item--active`).data('block');
      $(".home-upcoming-courses .course-image").removeClass("course-image--active");
      $(`.home-upcoming-courses .course-image[data-block="${blockID}"]`).addClass('course-image--active');
    });
  
    /*** Course Item click Event ***/
    $(document).on("click", ".home-upcoming-courses .course-list .course-item", function(e){
      $(this).closest(".course-list").find(".course-item").removeClass("course-item--active");
      $(this).addClass("course-item--active");
      let blockID = $(this).data('block');
      $(".home-upcoming-courses .course-image").removeClass("course-image--active");
      $(`.home-upcoming-courses .course-image[data-block="${blockID}"]`).addClass('course-image--active');
    });
  
    /** Display Active Course Image ***/
    function displayActiveCourseItemImage(){
      var activeCourseItemBlockId = null;
      if ( $(".home-upcoming-courses .course-type.course-type--active").hasClass("course-type-fundamentals")){
        activeCourseItemBlockId = $(".home-upcoming-courses .course-list.course-list-fundamentals .course-item.course-item--active").attr("data-block");
      }else if ( $(".home-upcoming-courses .course-type.course-type--active").hasClass("course-type-advanced")){
        activeCourseItemBlockId = $(".home-upcoming-courses .course-list.course-list-advanced .course-item.course-item--active").attr("data-block");
      }else{
        activeCourseItemBlockId = $(".home-upcoming-courses .course-list.course-list-live .course-item.course-item--active").attr("data-block");
      }
  
      if ( activeCourseItemBlockId != null ){
        $(".home-upcoming-courses .course-image").removeClass("course-image--active");
        $(".home-upcoming-courses .course-image[data-block='" + activeCourseItemBlockId + "']").addClass("course-image--active");
      }
      //adjustCourseListHeight();
    }
  
    /*** Adjust courseList Height ***/
    function adjustCourseListHeight(){
      var imageHeight = $(".home-upcoming-courses .course-image.course-image--active").height();
      if ( imageHeight == 0 ){
        $(".home-upcoming-courses .course-list").height("150vw");
      }else{
        $(".home-upcoming-courses .course-list").height(imageHeight);
      }
    }
    
    displayActiveCourseItemImage();
  
    $( window ).resize(function() {
      //adjustCourseListHeight();
    });


    /*** Team member click ***/
    function displayActiveMemberItem(){
      var currentBlockId = $(".home-team .member-item.member-item--active").attr("data-block");
      
      $(".home-team .member-items-arrows .member-items-arrow").removeClass("arrow-disable");
      if ( $(".home-team .member-item:first-child").attr("data-block") == currentBlockId ){
        $(".home-team .member-items-arrows .member-items-arrow.arrow-left").addClass("arrow-disable");
      }

      if ( $(".home-team .member-item:last-child").attr("data-block") == currentBlockId ){
        $(".home-team .member-items-arrows .member-items-arrow.arrow-right").addClass("arrow-disable");
      }

      $(".home-team .member-description").removeClass("member-description--active");
      $(".home-team .member-description[data-block='" + currentBlockId + "']").addClass("member-description--active");
    }
    
    $(document).on("click", ".home-team .member-item", function(e){
      if ( $(this).hasClass("member-item--active") == false ){
        $(".home-team .member-item").removeClass("member-item--active");
        $(this).addClass("member-item--active");
      }

      displayActiveMemberItem();
    });

    $(document).on("click", ".home-team .member-items-arrows .member-items-arrow", function(e){
      var currentMemberItem = $(".home-team .member-item.member-item--active");
      $(currentMemberItem).removeClass("member-item--active");
      if ( $(this).hasClass("arrow-left") ){
        $(currentMemberItem).prev().addClass("member-item--active");
      }
      else{
        $(currentMemberItem).next().addClass("member-item--active");
      }
      displayActiveMemberItem();
    });
    
    /*
    $(".home-team .member-items").slick({
      dots: false,
      arrows: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true
    });
    */


    /*** Display Testimonial Videos ***/
    function displayActiveTestimonialVideos(){
      var activeTestimonialType = $(".home-testimonials .testimonials-type.testimonials-type--active");
      $(".home-testimonials .testimonial-video").removeClass("testimonial-video--active");
      if ( $(activeTestimonialType).hasClass("testimonials-hands-on") ){
        $(".home-testimonials .testimonial-video[data-type='hands_on']").addClass("testimonial-video--active");
      }
      else if ( $(activeTestimonialType).hasClass("testimonials-look-learn") ){
        $(".home-testimonials .testimonial-video[data-type='look_learn']").addClass("testimonial-video--active");
      }
      else if ( $(activeTestimonialType).hasClass("testimonials-international") ){
        $(".home-testimonials .testimonial-video[data-type='international']").addClass("testimonial-video--active");
      }
    }
    displayActiveTestimonialVideos();
    $(document).on("click", ".home-testimonials .testimonials-types .testimonials-type", function(e){
      $(".home-testimonials .testimonials-type").removeClass("testimonials-type--active");
      $(this).addClass("testimonials-type--active");
      displayActiveTestimonialVideos();
    });


    /*** FAQ ***/
    $(document).on("click", ".home-faq .faq-items .faq-item .faq-item-question", function(e){
      $(this).closest(".faq-item").toggleClass("faq-item--active");
    });
  }
  //////////////////////////////////////////////////////////// End Home Page ////////////////////////////////////////////////////////



  
});